import { IDVGItemDTO, IGenericDTO } from "coreframetypings/dto";
import { IReadOnlyPrinterStatic } from '#/DefaultViewExtensionInterfaces';
import { staticImplements } from '@/Components/@Decorator/StaticImplementsDecorator';
import TypeConverter from '@/Utility/TypeConverter';
import * as DateHelper from '@/Utility/DateHelper'

@staticImplements<IReadOnlyPrinterStatic>()
export default class DateTimePrinter {
    public static print(item: IDVGItemDTO, value: string, row: IGenericDTO): HTMLElement {
        const dateValue = DateHelper.parseDotNetDateString(value);
        const dateTimeConfig = this.parseParams(item.uiGenerator);

        if (!dateTimeConfig.showDate && !dateTimeConfig.showTime) {
            // Ist keine Konfiguration vorhanden, dann zeige Wert nach gewaehlten UI-Generator an:
            //  - DatePicker -> Nur Datum
            //  - TimePicker -> Nur Zeit
            //  - DateAndTimePicker || DateTimeLabel -> Datum und Zeit
            switch (item.uiGenerator) {
                case 'DatePicker':
                    return this.buildHTMLElement(dateValue, false, true);
                case 'TimePicker':
                    return this.buildHTMLElement(dateValue, true, false);
                case 'DateAndTimePicker':
                case 'DateTimeLabel':
                    return this.buildHTMLElement(dateValue, true, true);
                default:
                    return undefined;
            }
        } else {
            return this.buildHTMLElement(dateValue, dateTimeConfig.showTime, dateTimeConfig.showDate);
        }
    }

    public static isRelevant(item: IDVGItemDTO, value: string, row: IGenericDTO): boolean {
        return TypeConverter.typeIsDateTime(item.dotNetTypeName);
    }

    public static createToolTip(item: IDVGItemDTO, value: string, row: IGenericDTO): string {
        return null;
    }

    private static parseParams(uiGenerator: string): IDateTimeConfiguration {
        let showDate: boolean = false;
        let showTime: boolean = false;

        const uiGeneratorParams = uiGenerator.split("?");
        if (uiGeneratorParams.length == 2) {
            uiGeneratorParams[1].split("&").forEach(configuration => {
                const paramValues = configuration.split("=");

                if (paramValues.length == 2) {
                    const attribute = paramValues[0].trim();
                    const value = paramValues[1].trim();

                    if (attribute === 'ShowDate')
                        showDate = value === 'true';
                    else if (attribute === 'ShowTime')
                        showTime = value === 'true';
                }
            });
        }

        return {
            showDate: showDate,
            showTime: showTime
        } as IDateTimeConfiguration;
    }

    private static buildHTMLElement(value: Date, showTime: boolean, showDate: boolean): HTMLElement {
        let spanElement = document.createElement('span');
        spanElement.textContent = DateHelper.toString(value, showTime, showDate);

        return spanElement;
    }
}

interface IDateTimeConfiguration {
    showTime: boolean;
    showDate: boolean;
}